
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg border-b-4 border-medimar-yellow">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/6214d334b00eb7faf97c61a8b8784857/89e3759e831ea9226f20f25512a960ed.png" 
              alt="MediMar Medical Market Logo" 
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-medimar-blue hover:text-medimar-orange transition-colors font-medium">Home</a>
            <a href="#services" className="text-medimar-blue hover:text-medimar-orange transition-colors font-medium">Services</a>
            <a href="#contact" className="text-medimar-blue hover:text-medimar-orange transition-colors font-medium">Contact</a>
            <a href="tel:941.286.4000" className="bg-gradient-to-r from-medimar-yellow to-medimar-orange hover:from-medimar-orange hover:to-medimar-yellow text-medimar-blue px-6 py-2 rounded-full font-semibold transition-all duration-300 whitespace-nowrap shadow-lg">
              Call Now
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-medimar-blue"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-medimar-cream pt-4">
            <div className="flex flex-col space-y-3">
              <a href="#home" className="text-medimar-blue hover:text-medimar-orange transition-colors font-medium">Home</a>
              <a href="#services" className="text-medimar-blue hover:text-medimar-orange transition-colors font-medium">Services</a>
              <a href="#contact" className="text-medimar-blue hover:text-medimar-orange transition-colors font-medium">Contact</a>
              <a href="tel:941.286.4000" className="bg-gradient-to-r from-medimar-yellow to-medimar-orange hover:from-medimar-orange hover:to-medimar-yellow text-medimar-blue px-6 py-2 rounded-full font-semibold transition-all duration-300 text-center whitespace-nowrap shadow-lg">
                Call Now
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
